import React from 'react'
import { chevron_right, contact_us, envelope, faq, see_more, user_guide, whatsapp } from '../../Images/Icons'
import { View } from '../../Components'
import { useNavigate, useOutletContext } from 'react-router-dom';

const ServicesPage = () => {
  const [showBottomSheet, hideBottomSheet] = useOutletContext();
  const navigate = useNavigate();

  const onUserGuide = () => {
    navigate('/services/userguide');
  }

  const onFaq = () => {
    navigate('/services/faq');
  }

  const onContactClick = () => {
    showBottomSheet("Contact Us",
      <div style={{ margin: 20, height: 140 }}>
        <div>
          <a href="https://wa.me/+6281196308732" target="_blank" style={{textDecoration:'none'}}>
            <div style={{
              height: 54, borderRadius: 50, background: 'white', display: 'flex',
              justifyContent: 'space-between', alignItems: 'center', padding: 12, cursor: 'pointer'
            }}>
              
              <img src={whatsapp} alt="" style={{ width: 38, height: 38 }} />
              <div style={{ flex: 1, fontSize: 16, fontWeight: 500, color: '#383C43', marginLeft: 20 }}>Whatsapp</div>
              <img src={chevron_right} alt="" style={{ width: 24, height: 24 }} />
            </div>
          </a>
          <a href="mailto:energy@modena.com" style={{textDecoration:'none'}}>
            <div style={{
              marginTop: 20, height: 54, borderRadius: 50, background: 'white', display: 'flex',
              justifyContent: 'space-between', alignItems: 'center', padding: 12, cursor: 'pointer'
            }}>
              <img src={envelope} alt="" style={{ width: 38, height: 38 }} />
              <div style={{ flex: 1, fontSize: 16, fontWeight: 500, color: '#383C43', marginLeft: 20 }}>Customer Care Email</div>
              <img src={chevron_right} alt="" style={{ width: 24, height: 24 }} />
            </div>
          </a>
        </div>
      </div>);
  }

  return (
    <div style={{}}>
      <div className="mainHeader" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
        <span style={{ color: 'white', fontSize: 18, fontWeight: 700 }}>Service</span>
      </div>
      <div style={{ height: 20, background: '#272727' }}></div>
      <div style={{ marginTop: -20, borderRadius: '12px 12px 0 0', height: '100%', background: '#F2F5FA' }}>
        <div style={{ padding: 16 }}>
          <div style={{ fontSize: 16, fontWeight: 500, color: '#515151', marginTop: 4 }}>Help and Feedback</div>
          <View justifyContent="space-between" style={{ marginTop: 20 }}>
            <div onClick={onUserGuide} style={{ flex: 1, marginRight: 8, height: 84, background: 'white', borderRadius: 8, cursor: 'pointer' }}>
              <div style={{ margin: 12 }}>
                <img src={user_guide} alt="" style={{ width: 32, height: 32 }} />
                <View justifyContent="space-between" style={{ marginTop: 8 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#292929' }}>User Guide</div><img src={see_more} alt="" style={{ width: 18, height: 18 }} />
                </View>
              </div>
            </div>
            <div onClick={onFaq} style={{ flex: 1, marginLeft: 8, height: 84, background: 'white', borderRadius: 8, cursor: 'pointer' }}>
              <div style={{ margin: 12 }}>
                <img src={faq} alt="" style={{ width: 32, height: 32 }} />
                <View justifyContent="space-between" style={{ marginTop: 8 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#292929' }}>FAQ</div><img src={see_more} alt="" style={{ width: 18, height: 18 }} />
                </View>
              </div>
            </div>
          </View>
          <View justifyContent="space-between" style={{ marginTop: 20 }}>
            <div onClick={onContactClick} style={{ flex: 1, height: 84, background: 'white', borderRadius: 8, cursor: 'pointer' }}>
              <div style={{ margin: 12 }}>
                <img src={contact_us} alt="" style={{ width: 32, height: 32 }} />
                <View justifyContent="space-between" style={{ marginTop: 8 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#292929' }}>Contact Us</div><img src={see_more} alt="" style={{ width: 18, height: 18 }} />
                </View>
              </div>
            </div>
          </View>
        </div>
      </div>
    </div>
  )
}

export default ServicesPage